
    let reviews;

    const initSlider = () => {
        reviews = new Swiper('.swiper-container.multicolumn-list', {
          slidesPerView: 3,
          spaceBetween: 40,
          effect: 'slide',
          breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 40
              }
          }
        });
    }
  
    const destroySlider = () => {
      if (reviews !== undefined) {
        reviews.destroy(true, true);
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
        initSlider();
      
    });
